import { createFileRoute } from '@tanstack/react-router'

// The leaf that makes the pathless `_list` layout match on bare `/admin/traces`; it renders nothing.
export const Route = createFileRoute('/_app/admin/traces/_list/')({})
